import React from "react";
import { Link } from "react-router-dom";
import carbelimLogo from "../assets/carbelim-logo.png";

const sections = [
  {
    title: "Information We Collect",
    body:
      "Carbelim collects account details, company or site information, device identifiers, telemetry data, report activity, and operational settings needed to provide the IoT platform.",
  },
  {
    title: "How We Use Information",
    body:
      "We use this information to authenticate users, show live device status, manage products and relays, generate reports, support customers, secure the platform, and improve reliability.",
  },
  {
    title: "Device And Telemetry Data",
    body:
      "Telemetry may include sensor values, timestamps, device health, status events, relay states, and related operational metadata. This data is used for monitoring, reporting, alerts, and platform controls.",
  },
  {
    title: "Sharing And Disclosure",
    body:
      "We do not sell personal information. Data may be shared with trusted infrastructure, hosting, analytics, storage, and support providers only as required to operate Carbelim services or comply with legal obligations.",
  },
  {
    title: "Security",
    body:
      "We use access controls, encrypted transport, authenticated APIs, and operational safeguards to protect platform data. No internet service is risk free, so users should keep credentials private and report suspected misuse.",
  },
  {
    title: "Data Retention",
    body:
      "We retain account, device, telemetry, and report data for as long as needed to provide services, meet business requirements, support audits, or satisfy legal obligations.",
  },
  {
    title: "User Choices",
    body:
      "Authorized users may request account updates, access changes, or data corrections through their organization administrator or Carbelim support.",
  },
  {
    title: "Contact",
    body:
      "For privacy questions or data requests, contact Carbelim support at admin@carbelim.io.",
  },
];

const PrivacyPolicy = () => {
  return (
    <main className="min-h-screen bg-[#f3f7f5] text-slate-950">
      <div className="border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4">
          <div className="flex items-center gap-3">
            <img
              src={carbelimLogo}
              alt="Carbelim"
              className="h-10 w-10 rounded-lg bg-emerald-50 p-1.5 ring-1 ring-emerald-100"
            />
            <div>
              <p className="text-lg font-black">Carbelim</p>
              <p className="text-xs font-bold uppercase text-emerald-700">IoT Platform</p>
            </div>
          </div>
          <Link to="/login" className="text-sm font-bold text-emerald-700 hover:underline">
            Login
          </Link>
        </div>
      </div>

      <section className="mx-auto max-w-5xl px-5 py-10">
        <div className="rounded-lg border border-white/80 bg-white p-6 shadow-xl shadow-slate-900/5 md:p-8">
          <p className="mb-3 inline-flex rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700">
            Effective 01 August 2026
          </p>
          <h1 className="text-3xl font-black tracking-tight md:text-4xl">Privacy Policy</h1>
          <p className="mt-4 max-w-3xl text-sm font-medium leading-7 text-slate-600 md:text-base">
            This Privacy Policy explains how Carbelim collects, uses, stores, and protects information when
            customers use the Carbelim IoT Platform, mobile application, dashboard, and related services.
          </p>

          <div className="mt-8 grid gap-4">
            {sections.map((section) => (
              <article key={section.title} className="rounded-lg border border-slate-200 bg-slate-50/70 p-5">
                <h2 className="text-lg font-black text-slate-900">{section.title}</h2>
                <p className="mt-2 text-sm font-medium leading-7 text-slate-600">{section.body}</p>
              </article>
            ))}
          </div>

          <p className="mt-8 text-xs font-semibold leading-6 text-slate-500">
            This page is provided for product transparency and app store review. It may be updated as the
            platform, legal requirements, or operational practices change.
          </p>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
